import { useMemo } from 'react';
import { useMoodleCourseContent, useMoodleCourses } from '../../../../hooks/useMoodleHooks';
import { MoodleInstanceKey } from '../../../../support/slices/moodleSlice';
import { buildMoodleLearningModel } from './MoodleLearningAdapter';

export function useMoodleLearningModel(courseId: string, instance: MoodleInstanceKey) {
  const courseIdNum = Number(courseId);

  const {
    data: sections = [],
    isLoading: loadingSections,
    error: sectionsError,
  } = useMoodleCourseContent(courseIdNum, { enabled: !!courseIdNum }, instance);

  const { data: allCourses = [] } = useMoodleCourses(undefined, instance);

  const courseTitle = useMemo(() => {
    const course = allCourses.find((c: any) => String(c.id) === String(courseId));
    return (
      course?.fullname ||
      course?.displayname ||
      course?.shortname ||
      `Course ${courseId}`
    );
  }, [allCourses, courseId]);

  const model = useMemo(() => {
    return buildMoodleLearningModel({
      courseId,
      courseTitle,
      sections,
    });
  }, [courseId, courseTitle, sections]);

  return {
    model,
    isLoading: loadingSections,
    error: sectionsError,
  };
}